@if (iShowDrivingEvents) {
  <div>
    <table class="table driving-table">
      <thead>
        <tr>
          @if (!iNavMobile && iShowStudent) {
            <th scope="col">#</th>
          }
          <th scope="col" class="driving-col-date">Date et heure</th>
          <th scope="col" class="driving-col-monitor">Moniteur</th>
          <th scope="col" class="driving-col-type">Type</th>
        </tr>
      </thead>
      <tbody>
        @for (d of iDrivingEvents; track d) {
          <tr [ngClass]="isConsumed(d.start) ? 'event-consumed' : 'event-reserved'">
            @if (!iNavMobile && iShowStudent) {
              <th scope="row">{{d.id}}</th>
            }
            <td>{{d.start | date:'dd/MM/yyyy HH:mm'}}</td>
            <td class="driving-col-monitor">{{d.extendedProps.monitor.firstname}}</td>
            <td class="driving-col-type">
              <span class="driving-type-badge" [ngClass]="d.extendedProps.boxType == 'AUTOMATIQUE' ? 'driving-type-badge--automatic' : 'driving-type-badge--manual'">
                {{ getBoxTypeLabel(d.extendedProps.boxType) }}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (iPageDrivingEvent) {
      <app-pagination [iEmpty]="iPageDrivingEvent.empty" [iFirst]="iPageDrivingEvent.first"
        [iLast]="iPageDrivingEvent.last" [iNumber]="iPageDrivingEvent.number" [iTotalPages]="iPageDrivingEvent.totalPages"
        [iPageSize]="iPageDrivingEvent.size"
        (currentPageChanged)="onChangeConsumptionPage($event)" >
      </app-pagination>
    }
  </div>
}
